import { render, staticRenderFns } from "./EcobankaTV.vue?vue&type=template&id=1a0f3d34&scoped=true&"
import script from "./EcobankaTV.vue?vue&type=script&lang=js&"
export * from "./EcobankaTV.vue?vue&type=script&lang=js&"
import style0 from "./EcobankaTV.vue?vue&type=style&index=0&id=1a0f3d34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0f3d34",
  null
  
)

export default component.exports